import { Grid } from "antd";

import { Text } from "@/components/Typography";

import { useAppBreadcrumbStore } from "../../AppBreadcrumb.store";

const { useBreakpoint } = Grid;

function PowerStationBreadCrumb() {
  const { xs } = useBreakpoint();

  const { label } = useAppBreadcrumbStore();

  return (
    <Text
      ellipsis
      style={{
        width: xs ? "150px" : undefined,
      }}
    >
      {label}
    </Text>
  );
}

export default PowerStationBreadCrumb;
